(function () {
  const res = function (energy, pips, anyPower, domains) {
    return { energy: energy, pips: pips, anyPower: anyPower, domains: domains };
  };

  const equip = function (cost, extra) {
    const x = extra || {};
    const ability = Object.assign({ cost: cost }, x, {
      label: "Equip",
      allowAttached: true,
      targets: [{ bind: "t", spec: { type: "unit", friendly: true }, prompt: x.prompt || "Equip to which unit?" }],
      program: [{ op: "attachSource", to: "$t" }],
    });
    delete ability.prompt;
    return ability;
  };

  const empower = function (cost, extra) {
    return Object.assign({ cost: cost }, extra || {}, {
      label: "Empower",
      requiresNotEmpowered: true,
      program: [{ op: "empowerSource" }],
    });
  };

  const buff = function (to, might) {
    return { op: "grant", to: to, might: might, dur: "turn" };
  };

  const addPerVarPoint = function (varKey, max, res) {
    const out = [];
    for (let i = 1; i <= max; i++) {
      out.push({ op: "if", cond: { k: "varAtLeast", key: varKey, n: i }, then: [{ op: "addResources", res: res }] });
    }
    return out;
  };

  window.RB.CardLib = window.RB.CardLib || {};
  Object.assign(window.RB.CardLib, { res: res, equip: equip, empower: empower, buff: buff, addPerVarPoint: addPerVarPoint });
})();
